import React, { useEffect } from 'react';

const RedirectPage = () => {
  useEffect(() => {
    // if not in localhost, redirect to www.edumetrics.cl
    if (window.location.hostname !== 'localhost') {
      window.location.replace('https://www.edumetrics.cl');
    }
  }, []);

  return <div>Redirecting...</div>;
};

export default RedirectPage;
